import { createContext } from 'react'

export const UserContext = createContext({ user: null, username: null, displayName: null, pro: null })
